<template>
  <div>
    <table class="st-table">
      <thead class="st-table__header">
        <tr class="st-table__header__row">
          <st-table-header
            v-for="(header, i) in headers"
            :key="`${header.name}-${i}`"
            :header="header"
            :is-sorted="sortBy === header.sortBy"
            @sort="handleSortClick"
          />
        </tr>
      </thead>
      <tbody class="st-table__body">
        <tr
          v-for="(data, index) in listData"
          :key="`table-row-${index}`"
          :class="classListRow(data)"
          @click="
            data.expandableRow
              ? expandRow(data.id)
              : $emit('on-row-click', data, index)
          "
          @keydown.enter="
            data.expandableRow
              ? expandRow(data.id)
              : $emit('on-row-click', data, index)
          "
          :tabindex="clickable ? '0' : '-1'"
        >
          <st-table-item
            v-for="(d, i) in data.items"
            :key="`${d.value}-${i}`"
            :data="d"
            :header="headers[i]"
            @on-item-click="$emit('on-item-click', index)"
          />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import StTableItem from "./TableItem.vue";
import StTableHeader from "./TableHeader.vue";
export default {
  name: "st-table",
  components: {
    StTableItem,
    StTableHeader,
  },
  props: {
    listData: {
      type: Array,
      validator: (items) => {
        const validItems = items.filter((item) => {
          if (!item.expandableRow) return true;
          return Object.prototype.hasOwnProperty.call(item, "id");
        });
        return validItems.length === items.length;
      },
    },
    headers: {
      type: Array,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      sortBy: "",
      isSelectedRow: "",
    };
  },
  methods: {
    isExpanded(id) {
      return id === this.isSelectedRow;
    },
    expandRow(id) {
      this.isSelectedRow = this.isSelectedRow === id ? "" : id;
    },
    handleSortClick(sortBy, order) {
      this.sortBy = sortBy;
      this.$emit("sort", sortBy, order);
    },
    classListRow(currentRow) {
      const row = "st-table__body__row";
      return [
        row,
        this.clickable && `${row}__clickable`,
        currentRow.state === "danger" && `${row}--is-danger`,
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

.st-table {
  font-family: $source-sans-pro;
  font-size: rem-calc(16);
  color: $dark-grey;
  width: 100%;
  &__header {
    background-color: $bg-grey;
    display: none;
    @include large {
      display: table-header-group;
    }
    &__row {
      border: solid $regn;
      border-width: rem-calc(2);
      vertical-align: baseline;
    }
  }
  &__body {
    &__row {
      background-color: $white;
      border: solid $regn;
      border-width: rem-calc(2);
      border-left: $orange solid rem-calc(2);
      display: flex;
      flex-direction: column;

      @include large {
        display: table-row;
      }
      &:focus {
        outline: rem-calc(2) solid $dark-grey;
      }
      &:nth-child(odd) {
        background-color: $sand;
      }
      &__clickable {
        cursor: pointer;
        @include org(st) {
          &:hover {
            background-color: $bright-orange;
          }
        }

        @include org(ot) {
          &:hover {
            background-color: #fef3f4;
          }
        }
      }
      @include org(ot) {
        border-left: $ot-light-red solid rem-calc(2);
      }
    }
    .st-table__body__row--is-danger {
      background-color: #fcdadc;
    }
  }
}
</style>
